<template>
    <div>
        <div v-if="Object.keys( deviceSwitchData ).length > 0" class="report-area">

            <div class="report-area-title-tag" id="report-area-sensor_parameter">{{ $t('menu.sensor_parameter') }}</div>

            <!-- 裝置選擇按鈕 -->
            <div class="report-area-card report-select-area">
                <div class="area-overflow-x grab-bing scroll-style block-area" v-dragscroll>
                    <b-form-group>
                        <b-form-radio-group v-model="selected_device" buttons>
                            <b-form-radio v-for="( data_device, key_hashid, idx_dd) in deviceSwitchData" :key="idx_dd" :value="key_hashid" button-variant="outline-success">
                                <span v-if="deviceInfo[ key_hashid ]">{{ deviceInfo[ key_hashid ].nickname }}</span>
                                ( {{ key_hashid }} )
                            </b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </div>
            </div>

            <div class="report-area-card" v-if="selected_device">

                <SoilTemperature    v-if="arranged_data[ selected_device ]['soil_temperature'] != undefined"
                                    :deviceHashid="selected_device"
                                    :deviceData="arranged_data[ selected_device ]['soil_temperature']"
                                    :deviceInfo="deviceInfo[ selected_device ]"
                                    :timeData="timeData"
                                    :dataDisplaySettings="chartDisplaySetting[ selected_device ]['soil_temperature']"
                ></SoilTemperature>

                <SoilMoisture       v-if="arranged_data[ selected_device ]['soil_moisture'] != undefined"
                                    :deviceHashid="selected_device"
                                    :deviceData="arranged_data[ selected_device ]['soil_moisture']"
                                    :deviceInfo="deviceInfo[ selected_device ]"
                                    :timeData="timeData"
                ></SoilMoisture>

                <SoilConductivity   v-if="arranged_data[ selected_device ]['soil_conductivity'] != undefined"
                                    :deviceHashid="selected_device"
                                    :deviceData="arranged_data[ selected_device ]"
                                    :deviceInfo="deviceInfo[ selected_device ]"
                                    :timeData="timeData"
                                    :dataDisplaySettings="chartDisplaySetting[ selected_device ]['soil_conductivity_residual']"
                ></SoilConductivity>

                <SoilPH             v-if="arranged_data[ selected_device ]['soil_ph'] != undefined"
                                    :deviceHashid="selected_device"
                                    :deviceData="arranged_data[ selected_device ]['soil_ph']"
                                    :deviceInfo="deviceInfo[ selected_device ]"
                                    :timeData="timeData"
                ></SoilPH>


            </div>

        </div>
    </div>
</template>

<script>
import { dragscroll } from 'vue-dragscroll'  // 滑鼠可拖拉 scroll 區域
import ecTools from '@/echarts/echarts-tools'

import SoilTemperature  from '@/views/project/report/components/Device_Sensor_Charts/soil_temperature'
import SoilMoisture     from '@/views/project/report/components/Device_Sensor_Charts/soil_moisture'
import SoilConductivity from '@/views/project/report/components/Device_Sensor_Charts/soil_conductivity'
import SoilPH           from '@/views/project/report/components/Device_Sensor_Charts/soil_ph'

export default {
    props: {
        deviceData: {
            type: Object,
            required: true,
        },
        deviceInfo: {
            type: Object,
            default: {},
        },
        timeData: {
            type: Object,
            default: function () { return {} }
        },
    },
    directives: {
        'dragscroll': dragscroll,
    },
    components: {
        SoilTemperature,
        SoilMoisture,
        SoilConductivity,
        SoilPH,
    },
    data () {
        return {
            deviceSwitchData: {},
            selected_device: undefined,
            arranged_data: {},
            chartDisplaySetting: {},
        }
    },
    mounted ()
    {
        this.arrangeDeviceInfo()
        this.arrangeChartDataList()
    },
    computed: {

    },
    watch: {

        deviceData (val, oldVal)
        {
            this.arrangeDeviceInfo()
            this.arrangeChartDataList()
        },

    },
    methods: {

        // 第一層整理：將資料結構改成以 deviceSwitchData = 感測器 - 繪圖參數 - 資料參數 - { log_time_type || value || dataset }
        arrangeDeviceInfo ()
        {
            this.deviceSwitchData = {}
            for (let _sensor_parameterKey in this.deviceData)
            {
                if ( _sensor_parameterKey == 'air' || _sensor_parameterKey == 'sun' || _sensor_parameterKey == 'water' || _sensor_parameterKey == 'volatile_material' )
                {
                    // Do Nothing：Air, Sun, Water 有其他繪製的 component，故在此不處理。
                }
                else
                {
                    for (let _deviceHashid in this.deviceData[ _sensor_parameterKey ])
                    {
                        if ( this.deviceSwitchData[ _deviceHashid ] == undefined )
                        {
                            this.deviceSwitchData[ _deviceHashid ] = {}
                        }

                        // 把原本 參數{ 裝置A{資料}, 裝置B{資料}, ... } 的資料結構改成 裝置{ 參數A{資料}, 參數B{資料}, ... }
                        this.deviceSwitchData[ _deviceHashid ][ _sensor_parameterKey ] = this.deviceData[ _sensor_parameterKey ][ _deviceHashid ]
                    }
                }

            }
        },

        // 取得標準資料
        addGeneralStandards (_refreshRules)
        {
        },

        // 取得多參數圖表要用的資料設定
        getChartDisplaySetting (device_hashid, chartType)
        {
            let _device_info = this.deviceInfo[ device_hashid ]
            let _settings = []
            let _standard = {}
            this.addGeneralStandards( _standard )

            _device_info.hashid = device_hashid
            if ( chartType == 'soil_temperature' )
            {
                _settings = [
                    // 說明：sensorMapping: function (_key, _device = undefined, _default_param = undefined, showKeyName = true, _allStandard = undefined)
                    ecTools.sensorMapping( 'daily_mean_soil_temp', _device_info, 'soil_temperature', true, _standard ),
                    ecTools.sensorMapping( 'daily_low_soil_temp', _device_info, 'soil_temperature', true, _standard ),
                    ecTools.sensorMapping( 'daily_high_soil_temp', _device_info, 'soil_temperature', true, _standard ),
                ];
                _settings[1].chart_type = 'line_area_min'
                _settings[2].chart_type = 'line_area_max'
            }
            else if ( chartType == 'soil_conductivity_residual' )
            {
                _settings = [
                    // 說明：sensorMapping: function (_key, _device = undefined, _default_param = undefined, showKeyName = true, _allStandard = undefined)
                    ecTools.sensorMapping( 'soil_conductivity', _device_info, 'soil_conductivity_residual', true, _standard ),
                    ecTools.sensorMapping( 'soil_moisture', _device_info, 'soil_moisture', true, _standard ),
                    ecTools.sensorMapping( 'soil_conductivity_residual', _device_info, 'soil_conductivity_residual', true, _standard ),
                ];
                _settings[2].chart_type = 'bar'
            }
            // console.log( _settings )
            return _settings;
        },

        // 整理資料用的，把感測器下面的資料整理成圖表要吃的格式
        appendData (data, arrangedData, dataKey)
        {
            if ( data && data[ dataKey ] != undefined )
            {
                // 要畫圖表的才會有 value 值
                if ( data[ dataKey ].value )
                {
                    arrangedData[ dataKey ] = data[ dataKey ].value
                }
                else
                {
                    arrangedData[ dataKey ] = data[ dataKey ]
                }
            }
        },
        // 第二層整理：將資料結構改成以 arranged_data = 感測器 - 繪圖參數 - 資料參數 - dataset (資料參數直接接資料集，不再多一層 value)
        arrangeChartDataList ()
        {
            this.arranged_data = {}
            this.chartDisplaySetting = {}

            for ( let _devHashID in this.deviceSwitchData )
            {
                // Echarts 用資料格式整理：參數後面直接接資料集( 去除 value 那一層 )
                let __data = this.deviceSwitchData[ _devHashID ]
                this.arranged_data[ _devHashID ] = {}

                // Echarts 圖表繪製設定
                this.chartDisplaySetting[ _devHashID ] = {}
                for ( let _sensorKey in __data )
                {
                    this.arranged_data[ _devHashID ][ _sensorKey ] = {}

                    for ( let _paramsKey in __data[ _sensorKey ] )
                    {
                        this.appendData( __data[ _sensorKey ], this.arranged_data[ _devHashID ][ _sensorKey ], _paramsKey )
                    }

                    this.chartDisplaySetting[ _devHashID ][ _sensorKey ] = this.getChartDisplaySetting( _devHashID, _sensorKey )
                }
            }

            // 自動選擇第一個裝置
            if ( Object.keys( this.deviceSwitchData ).length > 0 )
            {
                this.selected_device = Object.keys( this.deviceSwitchData )[0]
            }
            // console.log( this.arranged_data )
        },
    }
}
</script>

<style lang="scss" scoped>

.report-select-area
{
    padding-top: 25px !important;
}

</style>
